import { HazardPlusTotal, ResponseSuccess, Year } from "../../schema";

export const getDamageFromResponse = ({
  response,
  hazard,
  year,
}: {
  response: ResponseSuccess;
  hazard: HazardPlusTotal;
  year: Year;
}): number | null => {
  const { damage } = response.result.results.rcp85;
  const damageForHazard = hazard === "total" ? damage.total : damage.by_hazard[hazard];
  return damageForHazard[year];
};
